module.exports = "/images/ilustracion-planes.svg?22eaaf5a05bb71e199f04d2c262842db";